import { RootState } from "../../../redux-store";

export const selectDepartments = (state: RootState) =>
  state.data.departments.departments;

export const selectAllDepartments = (state: RootState) =>
  state.data.departments.allDepartments;
